// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"465":"calentario","658":"torneo","999":"institucion"}[chunkId] || chunkId) + "." + {"46":"8ae4dcc1","105":"e8b91d7b","465":"945f80cb","535":"29c8bf3b","658":"46b286b9","756":"591167c8","804":"9ba87a9a","872":"df065117","958":"9e42f415","999":"8dcdc3f4"}[chunkId] + ".js";
};